export const HostingPreferences = [
  {
    id: 'onCloud',
    name: 'On Cloud',
  },
  {
    id: 'onPremise',
    name: 'On Premise',
  },
  {
    id: 'hybrid',
    name: 'Hybrid',
  },
];
